import { render, staticRenderFns } from "./RatingsView.vue?vue&type=template&id=bb61ed26&scoped=true&"
import script from "./RatingsView.vue?vue&type=script&lang=js&"
export * from "./RatingsView.vue?vue&type=script&lang=js&"
import style0 from "./RatingsView.vue?vue&type=style&index=0&id=bb61ed26&prod&lang=scss&scoped=true&"
import style1 from "./RatingsView.vue?vue&type=style&index=1&id=bb61ed26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb61ed26",
  null
  
)

export default component.exports